module.exports = virt_jquery_all;